
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import VueSlideUpDown from 'vue-slide-up-down'
import { Nav, NavItem } from '@/pages/dashboard/entities/nav'
import CompanyLogo from '@/components/CompanyLogo.vue'
import { getCDNUrl } from '@/utils/cdn'

interface Selectable {
    selected?: boolean
}

type MenuBlock =
    | ({
          type: 'link'
          to?: string
          title: string
          selected?: boolean
          closed?: boolean
          hasSubLinks: boolean
      } & NavItem &
          Selectable)
    | {
          type: 'sublinks'
          id: string
          closed?: boolean
          href?: string
          target?: string
          links: Array<NavItem & Selectable>
      }

@Component<SubNavApp>({
    components: { CompanyLogo, VueSlideUpDown },
})
export default class SubNavApp extends Vue {
    @Prop({ type: Object, required: true }) public nav!: Nav
    public items = this.getItems()

    public get logoImg() {
        return getCDNUrl(this.nav.logo)
    }

    public getItems() {
        const { nav } = this
        const navItems = (nav && nav.items) || []

        const links: MenuBlock[] = []

        navItems.forEach((item) => {
            const hasSubLinks = !!(
                item.items &&
                item.items[0] &&
                item.items[0].title
            )

            const closed =
                (item.items || []).filter((a) => a.selected).length === 0
            if (item.title) {
                links.push({
                    id: item.title,
                    type: 'link',
                    title: item.title,
                    selected: !closed || item.selected,
                    closed,
                    href: item.href || '#',
                    target: item.target || '',
                    hasSubLinks,
                })
            }

            if (hasSubLinks) {
                links.push({
                    type: 'sublinks',
                    id: item.title as string,
                    closed,
                    links: item.items || [],
                    href: item.href || '#',
                    target: item.target || '',
                })
            }
        })

        return links
    }

    public shouldMaskPrevious(idx: number): boolean {
        const prev = this.items[idx - 1]
        return (
            prev &&
            prev.type === 'sublinks' &&
            prev.links &&
            prev.links.length > 5
        )
    }

    public toggleClose(item, idx) {
        if (item.hasSubLinks) {
            if (!item.closed) {
                // close current
                item.closed = !item.closed
                this.items[idx + 1].closed = item.closed
            } else {
                this.items.map((a, i) => {
                    if ((a as any).hasSubLinks) {
                        this.items[i + 1].closed = a.closed = a !== item
                    }
                })
            }
        } else {
            if (item.target === '_blank') {
                window.open(item.href, '_blank')
            } else {
                window.location.href = item.href
            }
        }
    }
}
